import { Box, Text } from '@fuegokit/react';
import { AfTransformIcon, AkWarningIcon, AfTimeIcon, AfUserIcon, AfLinkIcon, AfCheckIcon, AfCancelIcon, AfInfoIcon, AkDiscoverIcon, AfSearchIcon } from '@fuegokit/fuegoicons-react';
import { Code } from '@fuegokit/gatsby-theme-fuegodocs/src/components/Code';
import * as React from 'react';
export default {
  Box,
  Text,
  AfTransformIcon,
  AkWarningIcon,
  AfTimeIcon,
  AfUserIcon,
  AfLinkIcon,
  AfCheckIcon,
  AfCancelIcon,
  AfInfoIcon,
  AkDiscoverIcon,
  AfSearchIcon,
  Code,
  React
};